import React from 'react';
import {useQuery} from "@tanstack/react-query";
import {secretApi} from "../../../api/api";
import {sortChampData} from "../../../function";
import {useSelector} from "react-redux";

const UseLlmText = ({champion_id, enemy_champion_id}) => {
    const currentLang = useSelector((state) => state?.translation.lang);
    const query = useQuery({
        queryKey: ['llmText', champion_id, enemy_champion_id],
        staleTime: Infinity,
        queryFn: async () => {
            if (!champion_id || !enemy_champion_id) {
                return {}
            }
            const result = await llmTextApi({champion_id, enemy_champion_id})
            return {text: result,};
        },
        placeholderData: {
            text: [],
        },
    })
    return query
};
const llmTextApi = async ({champion_id, enemy_champion_id}) => {
    try {
        const url = new URL(`${process.env.REACT_APP_CACHE_API}matchup/matchup_stats`);
        url.searchParams.set('champion_id', champion_id);
        url.searchParams.set('enemy_champion_id', enemy_champion_id);
        const result = await secretApi.get(url.toString())
        const data = result.data.stats_by_position;
        const mapData = Object.entries(data).map((item) => {
            return {
                position: item[0],
                ...item[1],
            }
        });
        const sort = [{
            value: "games",
            sortType: false
        }, {
            value: "my_win_rate",
            sortType: false
        }]
        const sortedData = sortChampData(mapData, sort)
        return sortedData
    } catch (e) {
        console.log(e)
        return []
    }
}


export default UseLlmText;